import { createSlice } from "@reduxjs/toolkit"

export interface CustomizerState{
  messageFromChief:{
    name:string,
    value: {
        spokeperson: string,
        designation: string,
        image: string,
        description: string
    },
  }|undefined,
  loadingMFC:boolean,
  errorMFC:any
}

const initialstate:CustomizerState = {
  errorMFC:undefined,
  loadingMFC:false,
  messageFromChief:undefined
}

const customizerSlice  = createSlice({
  name:'customizer',
  initialState:initialstate,
  reducers:{
    fetchMFCrequest(state){
      state.loadingMFC = true;
    },
    fetchMFCsuccess(state,actions){
      state.loadingMFC = false;
      state.messageFromChief = actions.payload;
    },
    fetchMFCfail(state,actions){
      state.loadingMFC = false;
      state.errorMFC = actions.payload;
    } 
  }
});


export const {
  fetchMFCfail,
  fetchMFCrequest,
  fetchMFCsuccess
} = customizerSlice.actions;

export default customizerSlice.reducer;